import React, { useState } from "react";
import style from "./Details.module.scss";
import CaretDown24 from "../../../../assets/svg/icons/common/CaretDown24";
import useCommonStore from "../../../../stores/common";
import useMerchantStore from "../../../../stores/merchant";

function Financials() {
  const [isOpen, setIsOpen] = useState(false);
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const activeApp = useMerchantStore((state) => state.activeApp);

  return (
    <div
      className={`${style.accordion_item} ${expandDetails ? style.expanded : ""}`}
    >
      <div
        className={`${style.accordion_head} ${isOpen ? style.open : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <CaretDown24 />
        <h5>Financial</h5>
      </div>
      {isOpen && (
        <div className={style.accordion_body}>
          <div className={style.data_item}>
            <p className={style.data_label}>Monthly Cap</p>
            <p className={style.data_value}>
              $ {activeApp?.merchant_details?.MonthlyCap}.00
            </p>
          </div>
          <div className={style.data_item}>
            <p className={style.data_label}>Monthly Keyed Cap</p>
            <p className={style.data_value}>
              $ {activeApp?.merchant_details?.MonthlyKeyedCap}
            </p>
          </div>
          <div className={style.data_item}>
            <p className={style.data_label}>MTD Net Sales</p>
            <p className={style.data_value}>
              $ {activeApp?.merchant_details?.MonthToDateSales || 0}
            </p>
          </div>
          <div className={style.data_item}>
            <p className={style.data_label}>On Hold</p>
            <p className={style.data_value}>
              {activeApp?.merchant_details?.OnHold}
            </p>
          </div>
          <div className={style.data_item}>
            <p className={style.data_label}>Reserve</p>
            <p className={style.data_value}>
              {activeApp?.merchant_details?.Reserve}
            </p>
          </div>
          <div className={style.data_item}>
            <p className={style.data_label}>Reserve Bal</p>
            <p className={style.data_value}>
              $ {activeApp?.merchant_details?.ReserveBalance}.00
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Financials;
